/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Swiper, { Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { addBuild, setCurrentBuildIndex, removeBuild } from '../../actions';

import Warning from '../Browser/Warning';

const ProjectSwitcher = ({ currentBuildIndex, builds, dispatch, setEnableBuilder }) => {
    const [activeBuildIndex, setActiveBuildIndex] = useState(currentBuildIndex || 0);
    const [showWarning, setShowWarning] = useState(false);
    const [buildIndexToDelete, setBuildIndexToDelete] = useState(0);
    const swiperSlider = useRef(null);

    const handleDeleteClick = (buildIndex) => {
        setBuildIndexToDelete(buildIndex);
        setShowWarning(true);
    };

    const handleSwitchProjectClick = useCallback(
        (buildIndex) => {
            setActiveBuildIndex(buildIndex);
           
            dispatch(setCurrentBuildIndex(buildIndex));
            document.querySelector('.navigation__projectTitle').scrollIntoView();
        },
        [dispatch]
    );

    const updateIndexPostAdd = useCallback(() => {
        setActiveBuildIndex(builds.length);
    }, [builds]);

    const handleAddBuild = useCallback(() => {
        const builder = document.querySelector('.minifig-builder');
        builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        dispatch(addBuild());
        updateIndexPostAdd();
        setEnableBuilder(false);
        setEnableBuilder(false);
    }, [dispatch, updateIndexPostAdd, setEnableBuilder]);

    useEffect(() => {
        const swiper = new Swiper(swiperSlider.current, {
            // configure Swiper to use modules
            modules: [Scrollbar],
            spaceBetween: 10,
            slidesPerView: 2.3,
            scrollbar: {
                el: swiperSlider.current.querySelector('.swiper-scrollbar'),
                draggable: true,
                hide: false,
            },
            breakpoints: {
                480: {
                    spaceBetween: 20,
                    slidesPerView: 2.5,
                },
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 7,
                },
            },
        });

        if (swiper) {
            swiper?.update();
            swiper?.slideTo(activeBuildIndex);
        }
    }, [builds, activeBuildIndex]);

    return (
        <div className="navigation__project_switcher--wrapper">
            <div className="navigation__project_switcher">
                <div className="switcher__list_container swiper-container" ref={swiperSlider}>
                    <ul className="switcher__list swiper-wrapper">
                        {builds.map((build, buildIndex) => (
                            <React.Fragment key={`project-${build.projectTitle}`}>
                                <li
                                    className={classNames('switcher__list__item_project swiper-slide', {
                                        switcher__list_selected: currentBuildIndex === buildIndex,
                                    })}
                                >
                                    <button
                                        type="button"
                                        onClick={() => handleDeleteClick(buildIndex)}
                                        className="project-switcher-item__button project-switcher-item__button--remove"
                                    >
                                        Remove
                                    </button>
                                    {currentBuildIndex === buildIndex ? (
                                        <div>
                                            {builds[currentBuildIndex].projectTitle
                                                ? build.projectTitle.split(/[-*]/)[0]
                                                : '[Untitled]'}
                                        </div>
                                    ) : (
                                        <button
                                            className="project_switcher-item__switcher"
                                            onClick={() => handleSwitchProjectClick(buildIndex)}
                                        >
                                            {build.projectTitle ? build.projectTitle.split(/[-*]/)[0] : '[Untitled]'}
                                        </button>
                                    )}
                                </li>
                            </React.Fragment>
                        ))}
                    </ul>
                    <div className="swiper-scrollbar"></div>
                </div>
                <div className="switcher__list__buttons">
                    <div className="switcher__list__item_add">
                        <button className="" onClick={handleAddBuild}>
                            <span>Add new project</span>
                        </button>
                    </div>
                </div>
            </div>

            {showWarning && (
                <Warning
                    actionConfirm={() => {
                        setShowWarning(false);
                        dispatch(removeBuild(buildIndexToDelete));
                    }}
                    actionDeny={() => {
                        setShowWarning(false);
                    }}
                    warningText="Are you sure that you'd like to remove this project?"
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        currentBuildIndex: state.currentBuildIndex,
        builds: state.builds,
        buying: state.buying,
    };
};

export default connect(mapStateToProps)(ProjectSwitcher);
